import { AppMessageComponent } from './app-message.component';

export default angular
  .module('sfMobile.components.app-message', [
    'sfMobile.components.message',
    'sfMobile.services.pubsub',
  ])
  .component('sfAppMessage', AppMessageComponent).name;
